import TodaysOrderTable from "../components/Table/TodaysOrderTable";
import "./Dashboard.css";
import { useTranslation } from "react-i18next";
import AdminCharts from "../components/Charts/AdminCharts";
import DealerCharts from "../components/Charts/DealerCharts";
import { Button, notification, Space } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { getUrgentRequirements } from "../api/Users";
import { toast } from "react-toastify";


const Dashboard = (props) => {
  const { t } = useTranslation();
  const [api, contextHolder] = notification.useNotification();
  const [urgent, setUrgent] = useState(0);

  const navigate = useNavigate();

  // useEffect(() => {
  //   console.log(props.userData);
  //   if (props.role == 4) {
  //     const data = {
  //       role_id: props.role,
  //       UDISE_code: props.userData.data.UDISE_code,
  //     };

  //     getUrgentRequirements(data)
  //       .then((response) => {
  //         if (response.status == "success") {
  //           console.log("----------------------------------------", response.data[0].count_urgent)
  //           setUrgent(response.data[0].count_urgent);
  //           if (response.data[0].result === "true") {
  //             openNotification(response.data[0].count_urgent);
  //           }
  //         } else {
  //           console.error("Invalid response data format:", response.data);
  //         }
  //       })
  //       .catch((error) => {
  //         toast.error("Can't get urgent requirements");
  //       });
  //   } else if (props.role == 5) {
  //     const data = {
  //       role_id: props.role,
  //       block_code: props.userData.data.block_code,
  //     };

  //     getUrgentRequirements(data)
  //       .then((response) => {
  //         if (response.status == "success") {
  //           setUrgent(response.data[0].count_urgent);
  //           if (response.data[0].result === "true") {
  //             openNotification(response.data[0].count_urgent);
  //           }
  //         } else {
  //           console.error("Invalid response data format:", response.data);
  //         }
  //       })
  //       .catch((error) => {
  //         toast.error("Can't get urgent requirements");
  //       });
  //   } else if (props.role == 8) {
  //     const data = {
  //       role_id: props.role,
  //     };

  //     getUrgentRequirements(data)
  //       .then((response) => {
  //         if (response.status == "success") {
  //           setUrgent(response.data[0].count_urgent);
  //           if (response.data[0].result === "true") {
  //             openNotification(response.data[0].count_urgent);
  //           }
  //         } else {
  //           console.error("Invalid response data format:", response.data);
  //         }
  //       })
  //       .catch((error) => {
  //         toast.error("Can't get urgent requirements");
  //       });
  //   }
  // }, []);

  const close = () => {
    console.log(
      "Notification was closed. Either the close button was clicked or duration time elapsed."
    );
  };


  const openNotification = (count) => {
    const key = `open${Date.now()}`;
    const btn = (
      <Space>
        <Button
          size="big"
          type="primary"
          onClick={() => navigate("/managerequirements")}
        >
          {t("Check Requirements")}
        </Button>
      </Space>
    );
    notification.open({
      message: "",
      description: (
        <h4>
          {t("There are ")}<h3>{count} {t("Urgent Requirements!")}</h3>
        </h4>
      ),
      duration: 0,
      btn,
      key,
      onClose: close,
      placement: "bottomRight",
    });
  };
  

  return (
    <>
      <div className="px-2 px-md-3">
        <>
          {contextHolder}
          <AdminCharts role={props.role} userData={props.userData} />
          
        </>
      </div>
    </>
  );
};

export default Dashboard;
